module ProcessList {
    "use strict";
    export function processInstanceListDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            templateUrl: "ProcessInstanceListTemplate",
            controller: "ProcessInstanceListController as ctrl"
        }
    }
    module.directive("processInstanceList", [processInstanceListDirective]);

    export function processInstanceActionMenuDirective(): ng.IDirective {
        return {
            templateUrl: "ProcessInstanceActionMenuTemplate"
        }
    }
    module.directive("processInstanceActionMenu", [processInstanceActionMenuDirective]);


    export function processInstanceBatchActionMenuDirective(): ng.IDirective {
        return {
            templateUrl: "ProcessInstanceBatchActionMenuTemplate"
        }
    }
    module.directive("processInstanceBatchActionMenu", [processInstanceBatchActionMenuDirective]);
}